export default [
    {
        path: 'destino',
        component: () => import(
            '@/views/transporte-paciente/destino/Index'
        ),
        redirect: 'destino/list',
        children: [
            {
                name: 'transporte-paciente-destino-list',
                path: 'list',
                component: () => import(
                    '@/views/transporte-paciente/destino/List'
                ),
            },
            {
                name: 'transporte-paciente-destino-create',
                path: 'create',
                component: () => import(
                    '@/views/transporte-paciente/destino/Form'
                ),
            },
            {
                name: 'transporte-paciente-destino-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    '@/views/transporte-paciente/destino/Form'
                ),
            },
        ],
    },
]